import { Link } from "react-router-dom";
import { Phone, Clock, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS, BRAND } from "../data/siteData";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="border-t border-white/10 bg-[#070a12]"
    >
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
            <div className="space-y-4">
                <Logo />
                <p className="text-sm leading-relaxed text-slate-400">
                    {BRAND.trustLine}. Reliable FTTH broadband, TV and OTT
                    entertainment for homes and businesses in {BRAND.location}.
                </p>
                <span className="inline-flex items-center gap-2 rounded-full border border-[#E61C24]/40 bg-[#E61C24]/10 px-3 py-1.5 font-mono text-xs font-semibold tracking-widest text-[#ff6b70]">
                    15+ YEARS OF TRUST
                </span>
            </div>

            <div>
                <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-300">
                    Navigate
                </h4>
                <ul className="space-y-2.5">
                    {NAV_LINKS.map((link) => (
                        <li key={link.id}>
                            <Link
                                to={link.to}
                                data-testid={`footer-link-${link.id}`}
                                className="text-sm text-slate-400 transition-colors duration-200 hover:text-[#00F0FF]"
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-300">
                    Contact
                </h4>
                <ul className="space-y-3 text-sm text-slate-400">
                    {BRAND.phones.map((p) => (
                        <li key={p.raw}>
                            <a
                                href={p.tel}
                                data-testid={`footer-phone-${p.raw}`}
                                className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white"
                            >
                                <Phone className="h-4 w-4 text-[#E61C24]" />
                                {p.label}
                            </a>
                        </li>
                    ))}
                    <li className="flex items-center gap-2.5">
                        <Clock className="h-4 w-4 text-[#E61C24]" />
                        Customer Care: {BRAND.careHoursShort}
                    </li>
                    <li className="flex items-start gap-2.5">
                        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#E61C24]" />
                        {BRAND.location}
                    </li>
                </ul>
            </div>

            <div>
                <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-300">
                    Legal & Policies
                </h4>
                <ul className="space-y-2.5">
                    <li>
                        <Link
                            to="/privacy-policy"
                            data-testid="footer-link-privacy-policy"
                            className="text-sm text-slate-400 transition-colors duration-200 hover:text-[#00F0FF]"
                        >
                            Privacy Policy
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/terms-and-conditions"
                            data-testid="footer-link-terms"
                            className="text-sm text-slate-400 transition-colors duration-200 hover:text-[#00F0FF]"
                        >
                            Terms & Conditions
                        </Link>
                    </li>
                </ul>
            </div>
        </div>

        <div className="border-t border-white/10">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-slate-500 sm:flex-row sm:px-6 lg:px-8">
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} Eway Fiber Net. All Rights Reserved.
                </p>
                <p className="font-mono tracking-widest">
                    FTTH · TV · OTT — {BRAND.location}
                </p>
            </div>
        </div>
    </footer>
);
